export enum LoadersMethods {
  UpdateLoader = 'UpdateLoader',
  ResetLoader = 'ResetLoader',
}
